/* ===========================================================================
   Wasserfilter-Finder
   ---------------------------------------------------------------------------
   Zwei Fragen, danach wird die erste passende, bereits gerenderte
   Ergebniskarte eingeblendet. Es wird kein Markup in JavaScript erzeugt –
   alle Produktdaten kommen aus Liquid.
   =========================================================================== */

(function () {
  'use strict';

  function matches(pattern, value) {
    if (!pattern || pattern === '*') return true;
    return pattern === value;
  }

  function setupFinder(root) {
    if (root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';

    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
    var results = Array.prototype.slice.call(root.querySelectorAll('[data-result]'));
    var progress = Array.prototype.slice.call(root.querySelectorAll('[data-progress]'));
    var stepLabel = root.querySelector('[data-step-label]');
    var answers = ['', ''];
    var current = 0;

    function paint() {
      steps.forEach(function (panel) {
        panel.hidden = Number(panel.dataset.step) !== current;
      });

      var done = current >= steps.length;
      var shown = null;

      if (done) {
        for (var i = 0; i < results.length; i += 1) {
          var rule = results[i];
          if (
            !shown &&
            matches(rule.dataset.matchA, answers[0]) &&
            matches(rule.dataset.matchB, answers[1])
          ) {
            shown = rule;
          }
        }
      }

      results.forEach(function (panel) {
        panel.hidden = panel !== shown;
      });

      progress.forEach(function (bar, index) {
        bar.classList.toggle('is-done', current > index);
      });

      if (stepLabel) {
        stepLabel.textContent = String(Math.min(current + 1, steps.length));
      }
    }

    root.querySelectorAll('[data-answer]').forEach(function (button) {
      button.addEventListener('click', function () {
        var question = Number(button.dataset.question);
        answers[question] = button.dataset.value || '';
        current = question + 1;
        paint();
      });
    });

    root.querySelectorAll('[data-back]').forEach(function (button) {
      button.addEventListener('click', function () {
        current = Math.max(0, current - 1);
        paint();
      });
    });

    root.querySelectorAll('[data-reset]').forEach(function (button) {
      button.addEventListener('click', function () {
        answers = ['', ''];
        current = 0;
        paint();
      });
    });

    paint();
  }

  function init(root) {
    (root || document).querySelectorAll('[data-finder]').forEach(setupFinder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
